import type { DetailedHTMLProps, FormHTMLAttributes } from "react";

type Props = Omit<
  DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>,
  "noValidate"
>;

export const Form = ({ children, ...props }: Props) => (
  <form {...props} noValidate>
    {children}
  </form>
);

export default Form;
